module.exports = "<h1 id=\"按钮组件\">按钮组件</h1>\n";